// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useContext, createContext } from 'react';
export var SplitPanelContext = createContext({
  topOffset: 0,
  bottomOffset: 0,
  leftOffset: 0,
  rightOffset: 0,
  position: 'bottom',
  size: 0,
  getMaxWidth: function getMaxWidth() {
    return 0;
  },
  getMaxHeight: function getMaxHeight() {
    return 0;
  },
  getHeader: function getHeader() {
    return null;
  },
  isCopy: false,
  isOpen: true,
  isMobile: false,
  isRefresh: false,
  isForcedPosition: false,
  lastInteraction: undefined,
  splitPanelRef: undefined,
  splitPanelHeaderRef: undefined,
  onResize: function onResize() {},
  onToggle: function onToggle() {},
  onPreferencesChange: function onPreferencesChange() {},
  reportSize: function reportSize() {}
});
export function useSplitPanelContext() {
  return useContext(SplitPanelContext);
}